const KeyCode = {
  DOWN: 40,
  ENTER: 13,
  ESCAPE: 27,
  RIGHT: 39,
  SPACE: 32,
  TAB: 9,
  UP: 38
}

export default KeyCode
